import {
	mapState,
	mapActions
} from 'vuex';

import {
	isEqual,
	isEmpty,
	cloneDeep
} from 'lodash';

import {
	EventBus
} from '@/support/event-bus';

import toastr from '@/support/toastr';

export default {
	name: 'student-evacueted',
	data: () => ({
		evacuation: {
			shift: '',
			evacuation: '',
			quantity: ''
		}
	}),
	computed: {
		...mapState({
			classLevel: (state) => state.Class.selected.schoolClassLevel,
			dayShiftType: (state) => state.ENUM.DayShiftType,
			AgendaEvacuationType: (state) => state.ENUM.AgendaEvacuationType,
			evacuations: (state) => state.Agenda.agenda.evacuation
		})
	},
	methods: {
		...mapActions([
			'deleteEvacuationItem',
			'postAgendaEvacuationItem',
			'putAgendaEvacuationItem',
			'putCompletionStatus',
		]),
		formReset() {

			this.evacuation = {
				shift: '',
				evacuation: '',
				quantity: ''
			};

			this.putCompletionStatus({
				key: 'evacuation',
				value: true
			});

		},
		completionStatus(model) {

			let status = false;

			if (isEmpty(model.shift) && isEmpty(model.quantity) && isEmpty(model.evacuation)) {
				status = true;
			}

			this.putCompletionStatus({
				key: 'evacuation',
				value: status
			});

		},
		addEvacuationItem() {

			this.$validator.validateAll().then((valid) => {

				if (valid) {

					this.evacuations.map((value) => {

						this.evacuation.quantity = parseInt(this.evacuation.quantity);

						const valueClone = cloneDeep(value);
						delete valueClone.quantity;

						const modelClone = cloneDeep(this.evacuation);
						delete modelClone.quantity;

						if (isEqual(valueClone, modelClone)) {

							this.evacuation.index = this.evacuations.indexOf(value);
							this.evacuation.quantity = (parseInt(this.evacuation.quantity) + parseInt(value.quantity));

						}

					});

					if (this.evacuation.index !== undefined && this.evacuation.index >= 0) {
						this.putAgendaEvacuationItem(cloneDeep(this.evacuation));
					} else {
						this.postAgendaEvacuationItem(cloneDeep(this.evacuation));
					}

					this.evacuation = {
						shift: '',
						evacuation: '',
						quantity: ''
					};

					this.completionStatus(true);

				} else {
					toastr.warning('Por favor informar todos os campos relacionados a evacuação');
				}

			});

		},
		editEvacuationItem(index) {

			this.evacuation = cloneDeep(this.evacuations[index]);
			this.evacuation.index = index;

		}
	},
	mounted() {

		EventBus.$on('setStudent', () => {

			this.evacuation = {
				shift: '',
				evacuation: '',
				quantity: ''
			};

		});

	},
	beforeDestroy() {

		EventBus.$off('setStudent');

	}
};



// WEBPACK FOOTER //
// ./sources/domains/agenda/health/evacueted/index.js